import { CITY_RECORDS } from '../cities';
import type { CityEdition } from '../types';

/**
 * Charlotte (CLT) city edition — the MVP market, and the only registered
 * edition today.
 *
 * `code`, `displayName`, `locationCity`, `stateCode`, `timeZone` and `geography` are spread
 * from the shared record (API-1704) rather than restated, so this file cannot
 * drift from the registry every other surface derives from. Only the
 * edition-specific fields are declared here.
 *
 * Theme tokens and copy are intentional placeholders during the scaffold
 * milestone — M3 (APO-205 / FRE-703) drops in the LOCI · CLT colorway
 * (Loci Indigo + Electric Amber) and the launch copy.
 */
export const CLT: CityEdition = {
  ...CITY_RECORDS.CLT,
  iataCode: 'CLT',
  // COR-155: geography lives on the record; the edition only re-exposes it.
  defaultCenter: CITY_RECORDS.CLT.geography.defaultAnchor.center,
  defaultRadiusKm: CITY_RECORDS.CLT.geography.defaultAnchor.radiusKm,
  theme: {},
  copy: {},
};
